import React from 'react'
import './Banner.css'

function Banner() {
  return (
    <>
    <div className='banner'>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src="https://i.postimg.cc/FsjC4C70/1.png" className=" w-100" alt="..."/>
    </div>
    <div className="carousel-item">
    <img src="https://i.postimg.cc/Bn4YQ5Kk/2.png" className=" w-100" alt="..."/>
    </div>
    <div className="carousel-item">
    <img src="https://i.postimg.cc/mgjdcc3D/3.png" className=" w-100" alt="..."/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>

<div className='banner-mobile'>
<div id="carouselExampleControls2" className="carousel slide" data-bs-ride="carousel">
<div className="carousel-inner">
<div className="carousel-item active">
<img src="https://i.postimg.cc/43B27KgP/1.png" className=" w-100" alt="..."/>
</div>
<div className="carousel-item">
<img src="https://i.postimg.cc/mrb6gY0h/2.png" className=" w-100" alt="..."/>
</div>
<div className="carousel-item">
<img src="https://i.postimg.cc/4dyLzJ4g/3.png" className=" w-100" alt="..."/>
</div>
</div>
<button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="prev">
<span className="carousel-control-prev-icon" aria-hidden="true"></span>
<span className="visually-hidden">Previous</span>
</button>
<button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="next">
<span className="carousel-control-next-icon" aria-hidden="true"></span>
<span className="visually-hidden">Next</span>
</button>
</div>
</div>
</>
  )
}

export default Banner